
import React from "react";

import { ImageCustom } from '../Image';
import {
  LogoWrapper,
} from './style';

type LogosWrapperProps = {
  imgLink: string;
  imgAlt: string;
  productLink: string;
  props?: any;
};

const LogosWrapper = ({ imgLink, imgAlt, props }: LogosWrapperProps) => {

  return (
      <LogoWrapper>
          <ImageCustom src={imgLink} alt={imgAlt} />
      </LogoWrapper>
  );
}

export default LogosWrapper;


